// Mock data for Ozone A-1 Services

export const mockServices = [
  {
    id: 1,
    title: "Soft Services",
    icon: "Sparkles",
    description: "Professional housekeeping and hygiene services for corporate, industrial, and residential facilities.",
    features: [
      "HK & Cleaning Services",
      "Security & Safety",
      "Deep cleaning",
      "Pest Control Services ",
      "Corporate & Front Office Housekeeping",
      "Mall & Multiplex Cleaning",
      "Hospital & Healthcare Cleaning",
      "Deep Cleaning & Disinfection",
      
    ],
    image: "https://images.unsplash.com/photo-1669101602108-fa5ba89507ee?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 2,
    title: "Production & Support Services",
    icon: "Wrench",
    description: "Production and Support management ensuring uninterrupted operations and safety compliance.",
    features: [
      "Material & Equipment ",
      "Security Gadgets",
      "Ac Maintenance & CCTV ",
      "Transportation Services"
    ],
    image: "https://images.unsplash.com/photo-1651525670114-2b8117390b28?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 3,
    title: "Engineering Services",
    icon: "Wrench",
    description: "Technical facility management ensuring uninterrupted operations and safety compliance.",
    features: [
      "MEP Services (Mechanical, Electrical, Plumbing)",
      "Repair & Preventive Maintenance",
      "Fire System Installation & Maintenance",
    ],
    image: "https://images.unsplash.com/photo-1709102884400-b50ca1a12bc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtYWludGVuYW5jZSUyMHRlY2huaWNpYW4lMjB3b3JrfGVufDB8fHx8MTc3MDkwOTIwNHww&ixlib=rb-4.1.0&q=85"
  },
//{
//id: 5,
//title: "Security & Safety",
//icon: "Shield",
//escription: "Complete security manpower and support systems for comprehensive protection.",
//   features: [
//     "Trained Security Personnel",
//     "Security Gadgets & Equipment",
//     "CCTV & AC Maintenance",
//     "Transportation Services"
//   ],
//   image: "https://images.unsplash.com/photo-1496368077930-c1e31b4e5b44?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
// },
  {
    id: 4,
    title: "Other services",
    icon: "Settings",
    description: "maintenance services with structured inspection systems.",
    features: [
      "Electrical Repairs & Maintenance",
      "Plumbing Repairs",
      "Minor Civil Work",
      "Preventive Maintenance Services",
      "Emergency Breakdown Support",
      "Equipment Inspection"
    ],
    image: "https://images.unsplash.com/photo-1744302448222-b7ab4db49291?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtYWludGVuYW5jZSUyMHRlY2huaWNpYW4lMjB3b3JrfGVufDB8fHx8MTc3MDkwOTIwNHww&ixlib=rb-4.1.0&q=85"
  },
  //{
    //id: 5,
    //title: "Staffing Solutions",
    //icon: "Users",
    //description: "Professional manpower supply across sectors with verified and trained personnel.",
    //features: [
      //"Retail & Sales Associates",
      //"Skilled & Semi-skilled Staff",
      //"Office Support Staff",
      //"Technical Operators",
      //"Facility Supervisors",
      //"Contract Staffing"
 //   ],
  //    image: "https://images.unsplash.com/photo-1688380692117-63178554d76d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG9mZmljZSUyMG1lZXRpbmd8ZW58MHx8fHwxNzcwOTA5MjIxfDA&ixlib=rb-4.1.0&q=85"
  //}
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "Facility Manager, Tech Park Indore",
    content: "Ozone A-1 Services has been managing our facility for over a year now. Their professional approach and trained staff have significantly improved our operational efficiency.",
    rating: 5,
    company: "Tech Solutions Pvt Ltd"
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "Operations Head, Healthcare Center",
    content: "Excellent housekeeping and hygiene services. Their attention to detail and compliance with safety standards makes them our trusted partner.",
    rating: 5,
    company: "City Healthcare"
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "Director, Manufacturing Unit",
    content: "Reliable and cost-effective facility management solutions. Their engineering team is highly skilled and responsive to emergency situations.",
    rating: 5,
    company: "Industrial Solutions Ltd"
  }
];

export const mockClients = [
 {
    id: 1,
    name: "Client 1",
    logo: "https://i.pinimg.com/736x/07/81/b1/0781b183ad793d951cc46b8edf83b073.jpg"
  },
  {
    id: 2,
    name: "Client 2",
    logo: "https://www.tkelevator.com/media/press_1/press/global/241223_financial_news/tke_logo_claim_rgb_standard_gradient.webp"
  },
  {
    id: 3,
    name: "Client 3",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZnItX1o6Uo4Vubj-k5hSuvK0FKOnhsCsXpg&s"
  }
];

export const mockWhyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "Skilled & Trained Workforce",
    description: "Every team member undergoes professional training, safety orientation, and skill-based assessment."
  },
  {
    id: 2,
    icon: "UserCheck",
    title: "Professional & Verified Staff",
    description: "Strict background verification and structured onboarding process for all personnel."
  },
  {
    id: 3,
    icon: "FileCheck",
    title: "Compliance-First Approach",
    description: "PF, ESIC, labour law adherence, transparent payroll management and statutory compliance."
  },
  {
    id: 4,
    icon: "MonitorSmartphone",
    title: "Technology & Process Driven",
    description: "Defined SOPs, reporting systems, supervision structure, and measurable KPIs for accountability."
  }
];

export const mockSubscriptionPlans = [
  {
    id: 1,
    name: "Basic",
    price: "Contact Us",
    description: "Essential facility management services",
    features: [
      "Housekeeping Services",
      "Basic Maintenance",
      "Monthly Reporting",
      "Email Support"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "Contact Us",
    description: "Comprehensive facility solutions",
    features: [
      "All Basic Features",
      "Engineering Services",
      "Security Personnel",
      "24/7 Support",
      "Preventive Maintenance",
      "Quarterly Audits"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Contact Us",
    description: "Complete integrated facility management",
    features: [
      "All Professional Features",
      "Dedicated Account Manager",
      "Customized Solutions",
      "Advanced Reporting & Analytics",
      "Priority Response",
      "Annual Contract Benefits"
    ],
    popular: false
  }
];

// Mock form submission handlers
export const submitServiceRequest = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Service Request Submitted:", formData);
      resolve({ success: true, message: "Service request submitted successfully!" });
    }, 1000);
  });
};

export const submitNewsletter = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Newsletter Subscription:", email);
      resolve({ success: true, message: "Successfully subscribed to newsletter!" });
    }, 1000);
  });
};

export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact Form Submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll get back to you soon." });
    }, 1000);
  });
};
